<template>
  <div class="wrap" v-if="!loading">
    <img
      src="https://common-h5-dev.xiangshuheika.com/static/upload/2025050288039759d6b1e.png"
      class="img"
    />
    <div class="title">{{ pageInfo.name }}</div>
    <div class="desc">优惠福利天天享</div>
    <div class="list" v-for="item in pageInfo.productInfo" :key="item.id">
      <img :src="item.icon_img_url" class="list-img" />
      <div class="list-content">
        <div class="list-content-left">
          <div class="list-content-title">{{ item.desc }}</div>
          <div class="list-content-desc">
            <span class="face-price">¥{{ item.lowest_price }}</span>
            <span class="face-value">¥{{ item.lowest_face_value }}</span>
          </div>
        </div>
        <div class="action">
          <div
            class="btn"
            @click="handleBuy(item)"
            :class="{
              disable: item.benefit.amount + item.benefit.amount_reserved === 0,
            }"
            v-ans="{
              event_id: 'benefit_list_click',
              namespace,
              benefit_type: item.benefit_type,
            }"
          >
            {{
              item.benefit.amount + item.benefit.amount_reserved === 0
                ? "已领完"
                : "立即选购"
            }}
          </div>
          <div class="amount">
            剩{{ item.benefit.amount + item.benefit.amount_reserved || 0 }}次
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from "@vue/composition-api";

import { useStore, useRoute, useRouter } from "@/components/use/base";
import { getIndexCategory, getIndexClassList } from "@/apis/product";
import { getUserBenefit } from "@/apis/home";
import ans from "@/utils/ans";
import { jsonSafeParse } from "@/utils";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const card = ref({});
    const pageInfo = ref({});
    const loading = ref(false);

    const namespace = computed(() => store.state.namespace);

    onMounted(async () => {
      await getCardConfig();
    });

    const getCardConfig = async () => {
      const isBJ = vm.$getConfigValue("BJ_PAGE_CONFIG");
      const bjMap = jsonSafeParse(vm.$getConfigValue("BJ_CARD_MAP"));
      const page = isBJ ? bjMap[namespace.value].page : namespace.value;
      const openPage = route.query.open_page;
      ans.pageView("page_more_benefit", {
        namespace: namespace.value,
        display_code: openPage,
      });
      loading.value = true;
      const pageLoading = vm.$loading();
      try {
        const { data } = await getUserBenefit({
          card_status:
            vm.$getConfigValue("USER_BENEFIT_STAT_CARD_LIST") || undefined,
        });
        card.value = data;
        const { data: categoriesData } = await getIndexCategory({
          namespace: page,
          opened_page: "member-discount",
          source: "default",
        });
        const { data: productData } = await getIndexClassList({
          title: categoriesData.map((v) => v.name).join(","),
          opened_page: "member-discount",
          namespace: page,
        });
        const category =
          categoriesData.find((v) => v.display_code === openPage) || {};
        const productInfo = (productData[category.name] || []).map((item) => ({
          ...item,
          benefit:
            card.value.benefit_list.find((v) => item.benefit_type === v.type) ||
            {},
        }));
        pageInfo.value = {
          ...category,
          productInfo,
        };
      } finally {
        pageLoading.clear();
        loading.value = false;
      }
    };

    const handleBuy = (item) => {
      if (!(item.benefit.amount + item.benefit.amount_reserved)) return;
      router.push(`benefitDetail?benefit_type=${item.benefit_type}`);
    };

    return {
      pageInfo,
      loading,
      namespace,
      handleBuy,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  background: #110f0d;
  min-height: 100vh;
  position: relative;
  padding-bottom: 36px;

  > .img {
    width: 100%;
    height: 178px;
  }

  .title {
    position: absolute;
    top: 42px;
    left: 24px;
    font-size: 24px;
    color: #fff;
    text-align: center;
    margin-top: 10px;
    color: #bb9b93;
  }

  .desc {
    width: 115px;
    height: 23px;
    border-radius: 12px;
    border: 1px solid #dbb7af;
    text-align: center;
    font-size: 12px;
    color: #bb9b93;
    line-height: 23px;
    position: absolute;
    top: 90px;
    left: 28px;
  }

  .list {
    margin: 0 auto;
    width: 351px;
    height: 88px;
    background: linear-gradient(94deg, #fdf0e8 0%, #ffffff 100%), #24201d;
    border-radius: 8px;
    backdrop-filter: blur(10px);
    margin-bottom: 8px;
    padding-top: 24px;
    padding-left: 24px;
    box-sizing: border-box;
    display: flex;

    .list-img {
      height: 40px;
      width: 40px;
    }

    .list-content {
      margin-left: 22px;
      width: 100%;
      display: flex;
      justify-content: space-between;

      .list-content-title {
        font-weight: 600;
        font-size: 14px;
        color: #000000;
        line-height: 16px;
      }

      .list-content-desc {
        margin-top: 8px;

        .face-price {
          font-weight: 500;
          font-size: 21px;
          color: #000000;
          line-height: 16px;
        }

        .face-value {
          margin-left: 10px;
          color: #999999;
          font-size: 12px;
          text-decoration: line-through;
        }
      }

      .action {
        margin-top: 8px;
        margin-right: 24px;

        .btn {
          width: 78px;
          height: 24px;
          background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%), #000000;
          border-radius: 16px;

          font-weight: 500;
          font-size: 12px;
          color: #000000;
          line-height: 20px;
          text-align: center;
          line-height: 24px;
        }

        .amount {
          font-weight: 400;
          font-size: 10px;
          color: #000000;
          line-height: 24px;
          text-align: center;
        }

        &.disabled {
          background: #ccc;
          color: #fff;
        }
      }
    }
  }
}
</style>
